import { EyeIcon } from '@systemeio/ui/icons'
import { BreadcrumbsData, PrimaryButton } from '@systemeio/ui'
import EditFunnelModal from 'modules/funnels/funnel/components/edit-funnel-modal'
import { useFunnel } from 'modules/funnels/funnel/hooks/use-funnel'
import { FunnelStepInterface } from 'modules/funnels/funnel/types/funnel-step-interface'
import { FunnelId } from 'modules/funnels/types/funnel-interface'
import React from 'react'
import BreadcrumbsDashboard from 'shared/components/breadcrumbs'
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { useDeviceMode } from '../context/device-mode-context'

interface FunnelHeaderProps {
  funnelId: FunnelId
  selectedFunnelStep: FunnelStepInterface | null
}

function FunnelHeader({ funnelId, selectedFunnelStep }: FunnelHeaderProps) {
  const { t } = useLocoTranslation()
  const { resetSelectedMobileTab } = useDeviceMode()
  const { funnel } = useFunnel(funnelId)

  const breadcrumbsData: BreadcrumbsData[] = [
    {
      caption: t('dashboard.funnel.breadcrumbs.funnel_list'),
      href: '/funnels',
      isStatic: true,
    },
    { caption: funnel?.name ?? '', onClick: resetSelectedMobileTab },
    { caption: selectedFunnelStep?.name ?? '' },
  ]

  return (
    <div className="flex items-center justify-between gap-5">
      <BreadcrumbsDashboard data={breadcrumbsData} isFetching={!funnel} />
      <div className={'flex gap-2 whitespace-nowrap lg:gap-5'}>
        <PrimaryButton
          as={LinkWithoutPrefetch}
          aria-disabled={false}
          href={`/funnel/${funnelId}/show`}
          target={'_blank'}
          data-test-element={'view-funnel-button'}
        >
          <EyeIcon className={'fill-background-secondary'} />
          <span className={'hidden lg:flex'}>{t('dashboard.funnel.view_funnel')}</span>
        </PrimaryButton>
        <EditFunnelModal />
      </div>
    </div>
  )
}

export default FunnelHeader
